<div class="body-padding">
  <div class="flex flex-col items-baseline mb-4">
    <h1 class="general-font text-4xl	font-bold text-gray-900 dark:text-gray-100" id="jobs-title">Jobs</h1>
  </div>
  <div [formGroup]="filterForm" class="filter-form">
    <div>
      <label for="jobs-search-input"
             class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100">Search</label>
      <div id="jobs-search-container"
           class="flex items-center h-[36px] border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-700">
        <svg class="ml-2 h-5 w-5 pr-1 text-gray-600 dark:text-gray-300" width="15" height="16" viewBox="0 0 15 16"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <g id="Left Icon">
            <path id="Vector"
                  d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z"
                  stroke="currentColor"/>
          </g>
        </svg>
        <input id="jobs-search-input" formControlName="search" type="text" placeholder="Jobs Lookup"
               class="input-custom h-full py-0"/>
      </div>
    </div>
    <div>
      <label for="jobs-type-select" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100">
        Job Type
      </label>
      <ng-select id="jobs-type-select"
                 formControlName="type"
                 [items]="jobTypes"
                 bindValue="job_type_id"
                 bindLabel="job_type_name"
                 placeholder="All Job Types"
                 [clearable]="isSelectClearable('type')"
                 (clear)="clearSelectValue('type')"
                 class="min-w-[220px]">
        <ng-template ng-label-tmp let-item="item">
          <span [class.text-gray-500]="item.job_type_id === 0">{{ item.job_type_name }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span>{{ item.job_type_name }}</span>
        </ng-template>
      </ng-select>
    </div>
    <div>
      <label for="jobs-status-select"
             class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100">
        Job Status
      </label>
      <ng-select id="jobs-status-select"
                 formControlName="status"
                 [items]="jobStatuses"
                 bindValue="job_status_id"
                 bindLabel="job_status_name"
                 placeholder="All Statuses"
                 [clearable]="isSelectClearable('status')"
                 (clear)="clearSelectValue('status')"
                 class="min-w-[220px]">
        <ng-template ng-label-tmp let-item="item">
          <div class="flex items-center gap-2">
            @if (item.color) {
              <span class="w-3 h-3 rounded-full" [style.background-color]="item.color"></span>
            }
            <span [class.text-gray-500]="item.job_status_id === 0">{{ item.job_status_name }}</span>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="flex items-center gap-2">
            @if (item.color) {
              <span class="w-3 h-3 rounded-full" [style.background-color]="item.color"></span>
            }
            <span>{{ item.job_status_name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>
    <div>
      <label for="jobs-location-select" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        Location
      </label>
      <ng-select id="jobs-location-select"
                 [items]="locations"
                 formControlName="location"
                 bindValue="location_id"
                 bindLabel="location_name"
                 placeholder="Location Lookup"
                 [clearable]="isSelectClearable('location')"
                 (clear)="clearSelectValue('location')"
                 notFoundText="No location found">
        <ng-template ng-label-tmp let-item="item">
          <p [id]="'jobs-location-option-' + item.location_id || 'all'"
             [class.text-gray-500]="item.location_id === 0">
            {{ item.location_name }}
          </p>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div [id]="'jobs-location-option-' + item.location_id || 'all'">
            <p>{{ item.location_name }}</p>
            @if (item.full_address) {
              <p class="opacity-50">{{ item.full_address }}</p>
            }
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="relative" (clickOutside)="closeExportDropdown()">
      <label for="jobs-export-btn" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100 opacity-0">Export</label>
      <button id="jobs-export-btn"
              class="flex gap-2 items-center bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 rounded-md px-4 h-[36px] focus:ring-2 focus:outline-none hover:bg-gray-100 dark:hover:bg-gray-600"
              type="button"
              (click)="toggleExportDropdown()">
        Export
        <svg class="w-5 h-5 text-gray-800 dark:text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
             width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 10V4a1 1 0 0 0-1-1H9.914a1 1 0 0 0-.707.293L5.293 7.207A1 1 0 0 0 5 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2M10 3v4a1 1 0 0 1-1 1H5m5 6h9m0 0-2-2m2 2-2 2"/>
        </svg>
      </button>
      @if (isExportDropdownOpen) {
        <div id="jobs-export-dropdown"
             class="absolute left-0 mt-2 z-10 bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 rounded-lg shadow w-48">
          <ul class="py-2 text-sm text-gray-700 dark:text-gray-200">
            <li id="jobs-export-csv" (click)="handleExport('csv')"
                class="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
              Export to CSV
            </li>
            <li id="jobs-export-excel" (click)="handleExport('excel')"
                class="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
              Export to Excel
            </li>
          </ul>
        </div>
      }
    </div>
  </div>
  <ul class="flex gap-2 flex-wrap -mb-px text-lg font-normal text-center" id="default-tab" role="tablist">
    <li>
      <button id="pending-tab" class="tab-button" [class.selected-tab-button]="activeTab() === 'pending'"
              type="button" role="tab" aria-controls="pending" (click)="changeTab('pending')">
        Pending
      </button>
    </li>
    <li>
      <button id="completed-tab" class="tab-button" [class.selected-tab-button]="activeTab() === 'completed'"
              type="button" role="tab" aria-controls="completed" (click)="changeTab('completed')">
        Completed
      </button>
    </li>
  </ul>
  <div id="default-tab-content">
    @if (activeTab() === 'pending') {
      <custom-table
        id="jobs-pending-table"
        [columns]="jobsTableColumns()"
        [data]="pendingTableData()"
        primaryDataKey="job_id"
        [serverPagination]="true"
        [(currentPage)]="currentPendingTablePage"
        [loading]="loadingPendingTableData()"
        (paramsChange)="handlePendingJobsParamsChange($event)"
        emptyDataMessage="No Pending Jobs found"/>
    }
    @if (activeTab() === 'completed') {
      <custom-table
        id="jobs-completed-table"
        [columns]="jobsTableColumns()"
        [data]="completedTableData()"
        primaryDataKey="job_id"
        [serverPagination]="true"
        [(currentPage)]="currentCompletedTablePage"
        [loading]="loadingCompletedTableData()"
        (paramsChange)="handleCompletedJobsParamsChange($event)"
        emptyDataMessage="No Completed Jobs found"/>
    }
  </div>
</div>
<ng-template #jobNumberColumn let-row>
  <span class="font-semibold cursor-pointer text-gray-900 dark:text-gray-100 hover:underline"
        (click)="handleItemClicked(row)">
    {{ row[JobsTableColumn.JobNumber] }}
  </span>
</ng-template>
<ng-template #assetColumn let-row>
  @if (row[JobsTableColumn.Assets] && row[JobsTableColumn.Assets].length > 0) {
    <div class="flex flex-col gap-1">
      @for (item of getVisibleAssets(row[JobsTableColumn.Assets]); track $index) {
        <div class="flex gap-1" [class.text-gray-500]="item.IsOwner === false">
          <span class="truncate">
            {{ item.Make }} {{ item.Model }}
            <span class="font-bold">{{ item.SerialNumber }}</span>
          </span>
          <div class="custom-tooltip-not-owned-2">
            @if (item.IsOwner === false) {
              <svg class="w-4 h-4 text-gray-500 " aria-hidden="true"
                   xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
              </svg>
            }
            <div class="custom-tooltip-text-not-owned-2">
              This Asset has been relocated to another Company.
            </div>
          </div>
        </div>
      }

      @if (row[JobsTableColumn.Assets].length > unexpandedAssetsCount && isAssetExpanded(row.id)) {
        @for (item of getHiddenAssets(row[JobsTableColumn.Assets]); track $index) {
          <div class="flex gap-1" [class.text-gray-500]="item.IsOwner === false">
            <span class="truncate">
              {{ item.Make }} {{ item.Model }}
              <span class="font-bold">{{ item.SerialNumber }}</span>
            </span>
            <div class="custom-tooltip-not-owned-2">
              @if (item.IsOwner === false) {
                <svg class="w-4 h-4 text-gray-500 " aria-hidden="true"
                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 20">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                </svg>
              }
              <div class="custom-tooltip-text-not-owned-2">
                This Asset has been relocated to another Company.
              </div>
            </div>
          </div>
        }
      }

      @if (row[JobsTableColumn.Assets].length > unexpandedAssetsCount) {
        <div class="text-xs" stopClickPropagation>
          @if (isAssetExpanded(row.id)) {
            <button class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 underline"
                    type="button" (click)="toggleExpandedAssets(row.id, true)">
              Show less
            </button>
          } @else {
            <button class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 underline"
                    type="button" (click)="toggleExpandedAssets(row.id, false)">
              (+{{ row[JobsTableColumn.Assets].length - unexpandedAssetsCount }} more items)
            </button>
          }
        </div>
      }
    </div>
  }
</ng-template>

@if (isGeneratingReport) {
  <loading-overlay [message]="'Please wait while we are generating ' + currentFileType.toUpperCase() + ' document'"/>
}
